<template>
  <div class="tabs">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      class="tab"
      :class="{ active: tab.key === activeTab, disabled: tab.disabled }"
      :disabled="tab.disabled"
      @click="handleTabClick(tab.key)"
    >
      <span class="tab-label">{{ tab.label }}</span>
      <InformationOutlineIcon
        v-if="tab.tooltip"
        :size="16"
        class="info-icon"
        :title="tab.tooltip"
      />
    </button>
  </div>
</template>

<script>
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';

export default {
  name: 'TabBar',
  components: {
    InformationOutlineIcon
  },
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: (value) => {
        return Array.isArray(value) && value.every(tab =>
          tab && typeof tab.key === 'string' && typeof tab.label === 'string'
        );
      }
    },
    activeTab: {
      type: String,
      required: true
    }
  },
  methods: {
    handleTabClick(tabKey) {
      this.$emit('update:activeTab', tabKey);
    }
  },
  emits: ['update:activeTab']
}
</script>

<style scoped>
.tabs {
  display: flex;
  gap: 2px;
  align-items: center;
}

.tab {
  padding: 8px 16px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-label {
  display: inline-block;
}

.info-icon {
  color: #999;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.tab:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.02);
}

.tab:hover .info-icon {
  opacity: 1;
  color: #666;
}

.tab.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
  background-color: transparent;
}

.tab.active .info-icon {
  color: var(--primary-color);
  opacity: 0.8;
}

.tab:focus {
  outline: none;
}

.tab.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #999;
}

.tab.disabled:hover {
  color: #999;
  background-color: transparent;
}
</style>
